import { Variants, Transition } from 'framer-motion';

// Slide animations
export const slideVariants: Variants = {
  initial: {
    opacity: 0,
    x: 50,
  },
  in: {
    opacity: 1,
    x: 0,
  },
  out: {
    opacity: 0,
    x: -50,
  },
};

// Fade animations
export const fadeVariants: Variants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

// Scale animations
export const scaleVariants: Variants = {
  initial: {
    opacity: 0,
    scale: 0.8,
  },
  in: {
    opacity: 1,
    scale: 1,
  },
  out: {
    opacity: 0,
    scale: 1.1,
  },
};

// Slide up animations
export const slideUpVariants: Variants = {
  initial: {
    opacity: 0,
    y: 100,
  },
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: -100,
  },
};

// Slide down animations
export const slideDownVariants: Variants = {
  initial: {
    opacity: 0,
    y: -100,
  },
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: 100,
  },
};

// Transition configurations
export const transitions: Record<'smooth' | 'fast' | 'slow' | 'spring', Transition> = {
  smooth: {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5,
  },
  fast: {
    type: 'tween',
    ease: 'easeInOut',
    duration: 0.3,
  },
  slow: {
    type: 'tween',
    ease: 'easeInOut',
    duration: 0.8,
  },
  spring: {
    type: 'spring',
    stiffness: 100,
    damping: 20,
  },
};
